module.exports = __webpack_public_path__ + "img/zj3.cd5145a2.png";